import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SubmissionService } from '../../../services/submission/submissionsuccess.service';
import { BuyerDetailsComponent } from '../buyer-details/buyer-details.component';

@Component({
  selector: 'app-submission-success',
  templateUrl: './submission-success.component.html',
  styleUrl: './submission-success.component.scss',
  standalone: false
})
export class SubmissionSuccessComponent implements OnInit {
  @ViewChild(BuyerDetailsComponent)
  buyerDetailsComponent!: BuyerDetailsComponent;
  formData: any = {
    receiptDetails: null,
    buyerTIN: null,
    buyerDetails: null,
  };
  userEmail: string = '';
  constructor(
    private route: Router,
    private submissionService: SubmissionService
  ) {}
  ngOnInit(): void {
    console.log(this.formData);
    this.userEmail = this.submissionService.getBuyerEmail();
  }

  goToBuyerDetails() {
    this.submissionService.clearSubmissionStatus();
    this.submissionService.clearSubmissionemailStatus();
    this.route.navigateByUrl('/generate-invoice');
  }
  ngOnDestroy() {
    this.submissionService.clearSubmissionStatus();
    this.submissionService.clearSubmissionemailStatus();
  }
}
